(function () {
  function buildLinks() {
    var links = document.querySelectorAll('[data-oest-whatsapp]');
    var pageUrl = window.location.href;

    links.forEach(function (link) {
      var number = (link.dataset.whatsappNumber || '').replace(/\D/g, '');
      var template = link.dataset.whatsappMessage || '';
      if (!number) return;

      var message = template.split('[link]').join(pageUrl);
      link.href = 'https://wa.me/' + number + (message ? '?text=' + encodeURIComponent(message) : '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildLinks);
  } else {
    buildLinks();
  }
})();
